
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1590580985177",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "16102",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "1024",
    "height": "1024"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M755.2 243.2l70.4 76.8-89.6 89.6-19.2 19.2L716.8 448l0 339.2L307.2 787.2 307.2 448 307.2 422.4 288 403.2 198.4 313.6l70.4-70.4 96 0c38.4 38.4 96 64 147.2 64s115.2-25.6 147.2-70.4L755.2 236.8M780.8 179.2 627.2 179.2C608 224 563.2 249.6 512 249.6S416 224 396.8 179.2L243.2 179.2 134.4 281.6C128 300.8 128 326.4 134.4 339.2L243.2 448l0 358.4c0 25.6 19.2 44.8 44.8 44.8l441.6 0c25.6 0 44.8-19.2 44.8-44.8L774.4 448l115.2-108.8c12.8-12.8 12.8-38.4 0-57.6L780.8 179.2 780.8 179.2z",
        "p-id": "16103"
      }
    }
  ]
})
    }
  